var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":'myChart' + _vm.id,"role":"img","aria-label":_vm.chartDescription}})
}
var staticRenderFns = []

export { render, staticRenderFns }